import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Fire-and-forget tool click tracker.
 *
 * Uses navigator.sendBeacon when available so the request continues even
 * if the user navigates away (typical: clicking a tool opens it in a new
 * tab). Falls back to axios for older browsers.
 *
 * Never throws — engagement tracking must never block the click.
 */
export function trackToolClick(toolId) {
  if (!toolId) return;
  const url = `${API_BASE_URL}/api/tools/${toolId}/click`;
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      // sendBeacon ignores credentials by default; we pass an empty Blob
      // and rely on the existing session cookie set by the same origin.
      const blob = new Blob([], { type: 'application/json' });
      const ok = navigator.sendBeacon(url, blob);
      if (ok) return;
    }
    axios.post(url, {}, { withCredentials: true }).catch(() => {});
  } catch {
    /* swallow — never break click flow */
  }
}
